import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import { Assignment, AssignmentParams } from '@/models/assignment.ts';
import { Pagination } from '@/models';
import { buildQueryString, prepareHeaders } from '@/state/slices/index.ts';

export const AssignmentAPI = createApi({
  reducerPath: 'propertyAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['Assignment'],
  endpoints: (builder) => ({
    getAssignments: builder.query<Pagination<Assignment>, AssignmentParams>({
      query: (filters) => {
        const queryString = buildQueryString(filters as Record<string, string>);
        return {
          url: `/assignments/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'Assignment', id: 'LIST' },
              ...result.results.map((a) => ({
                type: 'Assignment' as const,
                id: a.uuid,
              })),
            ]
          : [{ type: 'Assignment', id: 'LIST' }],
    }),
    getAssignment: builder.query<Assignment, { uuid: string }>({
      query: ({ uuid }) => ({
        url: `/assignments/${uuid}/`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { uuid }) => [
        { type: 'Assignment', id: uuid },
      ],
    }),
  }),
});
export const {
  useGetAssignmentsQuery,
  useLazyGetAssignmentsQuery,
  useGetAssignmentQuery,
} = AssignmentAPI;
